import React from 'react';

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  controlClassName?: string;
  icon?: React.ReactNode;
  iconClassName?: string;
}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(({
  controlClassName,
  icon,
  iconClassName = 'field-icon',
  className,
  ...rest
}, ref) => {
  const textareaNode = <textarea ref={ref} className={className} {...rest} />;

  if (!icon) {
    return textareaNode;
  }

  return (
    <div className={controlClassName}>
      <span className={iconClassName} aria-hidden="true">
        {icon}
      </span>
      {textareaNode}
    </div>
  );
});

TextArea.displayName = 'TextArea';

export { TextArea };
